import WorkflowItem from './WorkflowItem'
import WorkflowConfigurationJson from './interfaces/WorkflowConfigurationJson'
import { WorkflowName } from './enums/WorkflowName'
import { DateTime } from 'luxon'

export default class WorkflowConfiguration {
  workflowItems: Array<WorkflowItem>

  constructor(workflowItems: Array<WorkflowItem>) {
    this.workflowItems = workflowItems
  }

  isWorkflowActive(name: WorkflowName, now: DateTime) {
    const workflow = this.workflowItems.find((item) => item.name === name)
    if (!workflow) {
      return false
    }

    return workflow.activationPeriods.isActive(now)
  }

  static fromJson(data: WorkflowConfigurationJson) {
    return new this(
      data.workflowItems.map((item) => WorkflowItem.fromJson(item)),
    )
  }
}
